import * as React from "react";
import {Container,Row, Col} from "reactstrap";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import About from "./About";
import ContactUs from "./ContactUs";
import Home from "./Home";
const ScrollIntoView = require("react-scroll-into-view");

import "./Main.css";


/**
 * 
 * 
 * @export
 * @class App
 * @extends {React.Component<{}, {}>}
 */
export default class Main extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);       
    }
    render() {
        return (                             
            <Router>
                <Container>               
                    <Row className = "header-container">
                       <Col sm="6" className = "logo header-menu">Jigarthanda</Col>
                       <Col sm="2" className = "header-menu">
                            <Link  to={'/'}>
                                Home
                            </Link>
                        </Col>
                       <Col sm="2" className = "header-menu">
                            <ScrollIntoView selector="#aboutUs">
                                <Link  to={'/'} >
                                    About Us
                                </Link>
                            </ScrollIntoView>
                        </Col>
                       <Col sm="2" className = "header-menu">
                            <ScrollIntoView selector="#contactUs">
                                <Link  to={'/'} >
                                    Contact Us
                                </Link>
                            </ScrollIntoView>
                        </Col>                       
                    </Row>
                    <Switch>
                       <Route exact path='/' component={Home} />                    
                    </Switch>
                </Container>
            </Router>           
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/views/Main.tsx